<template>
  <div
    :id="id"
    :class="{
      container: needsContainer,
      'my-24 first:mt-0 last:mb-0': !isTeaser,
    }"
  >
    <DrupalLink
      :to="to"
      class="focus:focusable group flex flex-col rounded-large bg-white p-20"
      :class="to ? 'shadow-lowered transition hover:shadow' : 'shadow'"
    >
      <div class="mb-16 text-xl font-semibold leading-tight text-blue-700">
        {{ title }}
      </div>
      <dl class="grid grid-cols-1 gap-15 sm:grid-cols-2 sm:gap-24">
        <div class="rounded-large bg-gray-50 p-16">
          <dt class="text-base font-regular text-gray-900 sm:text-lg">
            {{ $texts('pension_fund.netPerformance') }}
          </dt>
          <dd class="text-4xl font-semibold text-blue-700">
            {{ formatPercentage(initData.siteConfig.netPerformance) }}
          </dd>
        </div>
        <div class="rounded-large bg-gray-50 p-16">
          <dt class="text-base font-regular text-gray-900 sm:text-lg">
            {{
              $texts('pension_fund.regulatoryFundRatio')
            }}
          </dt>
          <dd class="text-4xl font-semibold text-blue-700">
            {{ formatPercentage(initData.siteConfig.fundedRatio) }}
          </dd>
        </div>
      </dl>
      <div v-if="to" class="mt-24 flex items-center gap-12">
        <span
          class="flex size-40 shrink-0 items-center justify-center rounded-full bg-blue-700 text-white group-hover:bg-blue-500"
        >
          <SpriteSymbol class="size-3/5" name="arrow-right" />
        </span>
        <span
          class="text-base font-regular text-blue-700 group-hover:text-blue-500 sm:text-lg"
        >
          {{
            $texts('pension_fund.goToFactsFigures')
          }}
        </span>
      </div>
    </DrupalLink>
    <p
      v-if="isEditing"
      class="mt-16 rounded border border-dashed border-gray-400 p-8 text-sm text-gray-700"
    >
      {{
        $texts('pension_fund.performanceFactsEditHint')
      }}
      <code class="font-semibold">/admin/config/publica/site-config</code>
    </p>
  </div>
</template>

<script lang="ts" setup>
const { options, parentType } = defineBlokkli({
  bundle: 'performance_facts',
  globalOptions: ['anchorId'],
  editor: {
    addBehaviour: 'no-form',
    disableEdit: true,
  },
})

const id = useAnchorId(options)
const isEditing = false

const initData = await useInitData()
const route = useRoute()

const to = computed(() => {
  const targetPath = initData.value.siteConfig.pageFactsFigures?.url?.path
  if (!targetPath || route.path === targetPath) {
    return undefined
  }
  return targetPath
})

const isTeaser = computed(() => parentType.value === 'grid')

const needsContainer = computed(
  () => !parentType.value || parentType.value === 'container',
)

const { $texts } = useEasyTexts()
const { formatPercentage } = useLocale()

const title = computed(() =>
  $texts('pension_fund.performanceFactsTitle').replace(
    '@date',
    initData.value.siteConfig.asOfDate?.formatted || '',
  ),
)

defineOptions({
  name: 'ParagraphPerformanceFacts',
})
</script>
